import AppState, { SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import Texts from 'react-sdk/Texts';
import classes from './ScreenEnd.module.css';

import Footer from '@/components/shared/Footer/Footer';
import { useEffect, useState } from 'react';
import Logo from '../ScreenHome/Logo/Logo';

const ScreenEnd = () => {

  const [loading, setLoading] = useState(!AppState.leaderboardDisabled);
  const [userPosition, setUserPosition] = useState(null);

  function getUserScore() {
    return new Promise( (resolve, reject) => {
      AppState.getGroupList().then(groups => {

        let universe = AppState.vertxClient.UserData.getUniverse()
        let collection = universe + "_Users"
        let queryParams = {
          // Filter: "",
          SortFields : { "CustomData.stars" : -1 },
          Projection: ["_id", "Pseudo", "CustomData.stars", "CustomData.group"],
          PageSize: 1,
          PageOffset: 0,
          FindIndexes: {
            _id: [AppState.vertxClient.UserData.getUserID()]
          }
        }
        
        if (!AppState.debugMode) {
          let disabledGroups = groups.filter(g => !g.enableRanking).map(g => g.groupId)
          disabledGroups.push("admin")
          disabledGroups.push("superadmin")
          queryParams.Filter = {$and : [{"CustomData.group" : {$exists: true}}, {"CustomData.group" : {$nin: disabledGroups}}]}
        }

        AppState.vertxClient.AdminQuery(collection, queryParams, (success, msg, data) => {
          let up = data?.Indexes?.[0]?.index
          console.log("up", up)
          resolve(up)
        })
      })
    })
  }

  useEffect(() => {
    if (!AppState.leaderboardDisabled) {
      getUserScore()
        .then((userPos) => {
          console.log("userPos", userPos)
          setUserPosition(userPos)
          setLoading(false)
        })
      // .then(() => {
      //   console.log("userPosition", userPosition)
      //   console.log("groupPosition", groupPosition)
      // })
    }
  }, []);
  function menuBtnClicked() {

    AppState.setScreen(SCREENS.MODULES)

  }
  function infoBtnClicked() {

    //AppState.setScreen(SCREENS.MODULES)

  }

  return (
    <div className={classes.ScreenEnd}>
      {/*<div className={classes.header}>
        <Logo />
      </div>*/}

      <Logo />



      <div className={classes.content} >
        <div className={classes.scoring}>
          {!AppState.leaderboardDisabled && !loading &&
          <>
            <div className={classes.position_block}>
              <div>Ta position</div>
              <strong>{userPosition+1}

                <span>{userPosition === 0 ? "ère" : "ème"}</span>
              </strong>
            </div>
          </>}
        </div>

        <div className={classes.texts}>
          <h1 className={classes.title}
          dangerouslySetInnerHTML={{__html: Texts.get("end-title") }}/>
          <div className={classes.text}
          dangerouslySetInnerHTML={{__html: Texts.get(AppState.leaderboardDisabled ? "end-content-leaderboard-disabled" : "end-content") }}/>

          <div className={classes.buttons_cntr}>
            <Button className={classes.menu_btn} onClick={menuBtnClicked} name="menuButton">
              {Texts.get("end-button-menu")}
            </Button>
            {/*<Button className={classes.infos_btn} onClick={infoBtnClicked} name="infosButton">
              {Texts.get("end-button-infos")}
            </Button>*/}
          </div>
        </div>


      </div>

      <div className={classes.chars_ctnr} >
        <img className={classes.chars} src={"data/images/LP_persos.png"} />
      </div>

      <Footer />
    </div>

  );
};

export default  observer(ScreenEnd)
